import { Component, OnInit } from '@angular/core';
import { Message } from "primeng/components/common/message";
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Router } from '@angular/router';
import { BookService } from '../../../services/book.service';
import { StorageService } from '../../../services/system/storage.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { CreateBookModel } from '../../../models/inModels/Book';

@Component({
  selector: 'app-book-create',
  templateUrl: './book-create.component.html',
  styleUrls: ['./book-create.component.css']
})
export class BookCreateComponent implements OnInit {
  model: CreateBookModel;
	loading = false;
	error: Message[];
	uploading = false;
	selectedAdvertType;
	adverts;
  constructor(
    private auth: AuthenticationService,
		private router: Router,
		private service: BookService,
		public storageService: StorageService,
		private confirmationService: ConfirmationService
  ) { 
    this.model = new CreateBookModel();
  }

  ngOnInit() {
  }

  goBack(): void {
		this.router.navigate(['/books']);
  }
  
  save(): void {
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				console.log(result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.coverId = result.PublicId;
		this.loading = false;
	}
	
  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.coverId = null;
		this.loading = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/book/book-create/book-create.component.ts